import {
    FETCH_METRICS
} from "../actions/types";

export const reducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_METRICS:
            return { ...state, metrics: action.payload };
        default:
            return state;
    }
};
